import { render, staticRenderFns } from "./TablePerformance.vue?vue&type=template&id=4a271c9c&"
import script from "./TablePerformance.vue?vue&type=script&lang=js&"
export * from "./TablePerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports